export const ukISOCodes = ["ENG", "NIR", "SCO", "WAL", "GGY", "IMN", "JEY"];
